import { vars } from '@/app/config/variables.js';
import { classInstance } from '@/shared/helpers/helpers';
import { ModalGalleryImages } from '@/features/modal/modal-gallery/modal-gallery-images/modal-gallery-images';

export class ModalGallery {
	private readonly openerSelector = '[data-gallery]';
	private readonly media = matchMedia(`(width >= ${vars.breakpoint.tablet}px)`);
	private openers: NodeListOf<HTMLButtonElement>;
	private imagesElement = new Set();

	constructor() {
		this.init();
	}

	private handleWindowClick = ({ target }): void => {
		const button: HTMLButtonElement = target.closest(this.openerSelector);
		const isOpen = button && !button.dataset.noMobile && this.media.matches;
		if (!isOpen) return;
		const { gallery, slide } = button.dataset;
		const images = classInstance.get(document.querySelector(`${gallery} .modal-gallery__images`))?.modalGalleryImages;

		images?.setOpenIndex(slide);
		(window as any).app.modal.open(gallery);
	};

	private getSliderElements = (): void => {
		this.openers.forEach((opener: HTMLButtonElement) => {
			this.imagesElement.add(document.querySelector(`${opener.dataset.gallery} .modal-gallery__images`));
		});
	};

	private initSliders = (): void => {
		this.imagesElement.forEach((element) => new ModalGalleryImages(element));
	};

	private bindEvents = (): void => {
		window.addEventListener('click', this.handleWindowClick);
	};

	private unbindEvents = (): void => {
		window.removeEventListener('click', this.handleWindowClick);
	};

	public init = (): void => {
		this.openers = document.querySelectorAll(this.openerSelector);
		this.bindEvents();
		this.getSliderElements();
		this.initSliders();
	};

	public destroy = (): void => {
		this.unbindEvents();
	};

	public reinit = (): void => {
		this.destroy();
		this.init();
	};
}
